import InvoiceRepository from './InvoiceRepository';

export default InvoiceRepository;
